import { Types } from "actions/synthpop-call-logs";
import { createReducer } from "utils/reducer";

const initialState = {
  metrics: null,
  isFetchingMetrics: false,
  callLogs: [],
  callLogsTotalCount: 0,
  callLogsPage: 1,
  callLogsPageSize: 50,
  callLogsTotalPages: 0,
  isFetchingCallLogs: false,
  pendingSummary: null,
  isFetchingPendingSummary: false,
  patientPending: null,
  isFetchingPatientPending: false
};

export default createReducer(initialState, {
  [Types.SYNTHPOP_CALL_LOG_METRICS_REQUEST]: state => ({
    ...state,
    isFetchingMetrics: true
  }),
  [Types.SYNTHPOP_CALL_LOG_METRICS_SUCCESS]: (state, action) => ({
    ...state,
    metrics: action.payload,
    isFetchingMetrics: false
  }),
  [Types.SYNTHPOP_CALL_LOG_METRICS_FAILURE]: state => ({
    ...state,
    isFetchingMetrics: false
  }),
  [Types.SYNTHPOP_CALL_LOGS_REQUEST]: state => ({
    ...state,
    isFetchingCallLogs: true
  }),
  [Types.SYNTHPOP_CALL_LOGS_SUCCESS]: (state, action) => ({
    ...state,
    callLogs: action.payload.callLogs || [],
    callLogsTotalCount: action.payload.totalCount || 0,
    callLogsPage: action.payload.page || 1,
    callLogsPageSize: action.payload.pageSize || 50,
    callLogsTotalPages: action.payload.totalPages || 0,
    isFetchingCallLogs: false
  }),
  [Types.SYNTHPOP_CALL_LOGS_FAILURE]: state => ({
    ...state,
    isFetchingCallLogs: false
  }),
  [Types.SYNTHPOP_PENDING_SUMMARY_REQUEST]: state => ({
    ...state,
    isFetchingPendingSummary: true
  }),
  [Types.SYNTHPOP_PENDING_SUMMARY_SUCCESS]: (state, action) => ({
    ...state,
    pendingSummary: action.payload,
    isFetchingPendingSummary: false
  }),
  [Types.SYNTHPOP_PENDING_SUMMARY_FAILURE]: state => ({
    ...state,
    isFetchingPendingSummary: false
  }),
  [Types.SYNTHPOP_PATIENT_PENDING_REQUEST]: state => ({
    ...state,
    isFetchingPatientPending: true
  }),
  [Types.SYNTHPOP_PATIENT_PENDING_SUCCESS]: (state, action) => ({
    ...state,
    patientPending: action.payload,
    isFetchingPatientPending: false
  }),
  [Types.SYNTHPOP_PATIENT_PENDING_FAILURE]: state => ({
    ...state,
    isFetchingPatientPending: false
  }),
  [Types.SYNTHPOP_PATIENT_PENDING_CLEAR]: state => ({
    ...state,
    patientPending: null
  })
});

export const selectors = {
  getSynthpopMetrics: state => state.get("synthpop-call-logs")?.metrics,
  getIsFetchingSynthpopMetrics: state => state.get("synthpop-call-logs")?.isFetchingMetrics,
  getSynthpopCallLogs: state => state.get("synthpop-call-logs")?.callLogs || [],
  getSynthpopCallLogsTotalCount: state => state.get("synthpop-call-logs")?.callLogsTotalCount || 0,
  getSynthpopCallLogsPage: state => state.get("synthpop-call-logs")?.callLogsPage || 1,
  getSynthpopCallLogsPageSize: state => state.get("synthpop-call-logs")?.callLogsPageSize || 50,
  getSynthpopCallLogsTotalPages: state => state.get("synthpop-call-logs")?.callLogsTotalPages || 0,
  getIsFetchingSynthpopCallLogs: state => state.get("synthpop-call-logs")?.isFetchingCallLogs,
  getSynthpopPendingSummary: state => state.get("synthpop-call-logs")?.pendingSummary,
  getIsFetchingSynthpopPendingSummary: state => state.get("synthpop-call-logs")?.isFetchingPendingSummary,
  getSynthpopPatientPending: state => state.get("synthpop-call-logs")?.patientPending,
  getIsFetchingSynthpopPatientPending: state => state.get("synthpop-call-logs")?.isFetchingPatientPending
};
